import { setCookie, getCookie } from "@/utils/helpers/cookie.js";
import { i18n } from "./i18n";

export function changeLocale(locale) {

    let isCookieSecure = true;
    if (process.env.VUE_APP_ENVIRONMENT_NAME === "local") {
        isCookieSecure = false;
    }

    var cookiesAccepted = getCookie("COOKIES_ACCEPTED");

    if (cookiesAccepted) {
        setCookie("LANGUAGE", locale, {"path": "/", "domain": process.env.VUE_APP_ROOT_URL, "httponly": false, "expires": 525600, "samesite": "Strict", "secure": isCookieSecure});
    }

    i18n.locale = locale;
}

export function cleanLocale(locale) {
    const isAstro = (locale.slice(-6) === "-astro") ?  true : false;

    if (isAstro) {
        return locale.slice(0, -6);
    }

    return locale;
}